/**
 * 前后端数据同步机制，主要分为两大块：
 * - push：对实时性要求比较高的消息推送(订单状态、重要提醒等)
 * - 轮询：定时拉取一些对实时性要求相对较低的信息(set化参数、前端静态资源版本等)以及作为 push 的兜底(比如新订单轮询)
 */

import initPollChannel from './pull';
import initBackgroundTasks from '../tasks';

/** 建立后端通信 */
const init = () => {
    initBackgroundTasks();
    initPollChannel();
};

export default init;
